import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const LEADING_SIGN: RegExp = /^\s*[+\-=@]/;

export const STREET_LINE_SIGN_HINT: string =
    'Address cannot start with +, -, = or @';

export function streetLineValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value: unknown = control.value;
        if (typeof value !== 'string') {
            return null;
        }
        return LEADING_SIGN.test(value) ? { leadingSign: true } : null;
    };
}

export function requiredStreetLineValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value: unknown = control.value;
        return typeof value === 'string' && value.trim() !== ''
            ? null
            : { required: true };
    };
}

export function trimStreetLine(line: string): string;
export function trimStreetLine(
    line: string | null | undefined,
): string | null | undefined;
export function trimStreetLine(
    line: string | null | undefined,
): string | null | undefined {
    return typeof line === 'string' ? line.trim() : line;
}
